<script>
export default {
	name: "configurable",
	props: {
		config: {}
	}
}
</script>
